import * as actions from './languageActions';

const languageReducers = {
  [actions.LANGUAGE_SELECTED]: (state, { language }) => {
    state.selected = language;
    return state;
  },
};

export default languageReducers;
